module.exports = __webpack_public_path__ + "static/media/Ship.965373f6.svg";